import React, { useState, useEffect } from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';
import '../HS/FinalizedCourses.css';
import PossibilitiesModal from './PossibilitiesModal';
import { getFirestore, doc, getDoc, setDoc } from 'firebase/firestore';
import { useAuth } from '../../contexts/AuthContext';
import { db } from '../firebase';
import { FaCheck, FaCheckDouble, FaPlus } from 'react-icons/fa';
import CourseRendering from './CourseRendering';
import { toast } from 'react-toastify';
import ElectiveSidebar from './ElectiveSidebar';
import { useTranslation } from 'react-i18next';

// Component to render a single finalized course card
const FinalizedCourse = ({
  course,
  onRemove,
  onKeepCourse,
  isPrereqMet,
  onCheckboxChange,
  semester,
  year,
  onPossibilityClick,
  selectedPossibility,
  selectedCourses,
  onShowPossibilitiesClick,
  onShowPossibilitiesClick1,
  onElectiveClick,
  isSelected,
  handleSaveMilestone,
  onAddPlaceholder,
  semesterCourses,
  finalizedCourses,
  finalizedSemesterMilestones
}) => {
  const { t } = useTranslation();
  const [isCardExpanded, setCardExpanded] = useState(false);
  const [showPossibilitiesButton, setShowPossibilitiesButton] = useState(false);
  // console.log('Passed in course: ', course);
  // Show "Add Placeholder" button if the course is an elective or requirement
  const showAddPlaceholderButton =
    course.courseType === 'Elective' || course.courseType === 'Requirement';

  const handleCardClick = () => {
    if (!course.isKept) {
      onCheckboxChange(course, !isSelected);
    }
  };
  // console.log('isKept', course.courseType == 'Elective' ? 
  //   course.isKept : ''
  // );


  if (course.courseType === 'Elective') {
    if (course.Possibilities === 'Free-NonMajor-Elective') {
      const majorCourseNumbers = finalizedCourses
        .filter((majorCourse) => majorCourse.courseType === 'Major Course')
        .map((majorCourse) => majorCourse.courseInfo_courseNumber);
      course.isKept = semesterCourses.some(
        (userCourse) =>
          !majorCourseNumbers.includes(userCourse.courseInfo_courseNumber)
      );
    } 
    else {
      course.isKept = semesterCourses.some(semesterCourse => 
        semesterCourse.Elective_fulfillment && semesterCourse.Elective_fulfillment.includes(course.Possibilities)
      );
    }
  }
  if (course.courseType === 'Requirement') {
    course.isKept = semesterCourses.some(semesterCourse =>
      course.Possibilities && course.Possibilities.includes(semesterCourse.courseInfo_courseNumber)
    );
  }
  if (course.courseType === 'Milestone') {
    course.isKept = finalizedSemesterMilestones['milestones']?.some(
      (milestone) => milestone.Title[0] === course.Requirements[0]
    );
  }



  const handleExpandClick = (e) => {
    e.stopPropagation();
    setCardExpanded(!isCardExpanded);
    setShowPossibilitiesButton(!isCardExpanded);
  };
  // console.log('coursePoss: ', course.Possibilities);
  // console.log('coursePoss1: ', course.Possibilities.trim());

  const hasPossibilities =
    course.Possibilities && course.Possibilities.trim().length > 0;
    // console.log('coursePoss: ', course.Possibilities);

  return (
    <div
      className={`relative flex justify-between card ${
        isSelected ? '!border-black' : ''
      } ${isPrereqMet ? '' : 'bg-orange-200'} ${
        isCardExpanded ? 'expanded' : ''
      } ${course.isKept ? 'bg-blue-100' : ''} ${
        course.courseType === 'Milestone' && course.milestoneExistsInPlan
          ? 'bg-blue-100'
          : ''
      } rounded-lg`}
      onClick={
        course.courseType === 'Elective'
          ? () =>
              onElectiveClick(
                course.Possibilities,
                year,
                semester,
                course.Requirements
              )
          : course.courseType === 'Requirement'
          ? () => onShowPossibilitiesClick(course)
          : course.courseType === 'Milestone'
          ? () =>
              handleSaveMilestone(year, course.Requirements, course.Requirements)
          : handleCardClick
      }
    >
      {/* "Add Placeholder" Button */}
      {showAddPlaceholderButton && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onAddPlaceholder(course, year, semester);
          }}
          className="absolute top-2 right-2 text-blue-500 hover:text-blue-700"
          title={t('finalizedCourses.addPlaceholder', 'Add Placeholder')}
        >
          <FaPlus />
        </button>
      )}

      {course.courseType === 'Elective' ? (
        <div className="flex items-center justify-between p-2">
          <div className="w-1/5">
            <div className="course-number mr-4">
              <strong>{t('finalizedCourses.elective', 'Elective')}</strong>
            </div>
            <span
              className={`inline-flex ${
                course.isKept ? 'bg-white' : 'bg-blue-100'
              } text-blue-800 text-[9px] font-medium px-1 py-0.5 rounded mr-11`}
            >
              {course.Credits
                ? `${course.Credits} ${t('finalizedCourses.credits', 'Credits')}`
                : `3-5 ${t('finalizedCourses.credits', 'Credits')}`}
            </span>
          </div>
          <div className="flex-1 w-2/5 text-left pl-4 text-sm truncate">
            <span>{course.Requirements}</span>
          </div>
          <div className="flex flex-col items-start justify-center mr-5 text-left pl-2 text-sm">
            {course.degreeName && (
              <div className="flex items-center justify-start">
                <span className="text-green-500 text-xs bg-green-100 bg-opacity-50 rounded px-2 py-1 font-semibold max-w-[100px] overflow-hidden text-ellipsis whitespace-nowrap">
                  {course.degreeName}
                </span>
              </div>
            )}
            {course.minorName && (
              <div className="flex items-center justify-start mt-1">
                <span className="text-yellow-500 text-xs bg-yellow-100 bg-opacity-50 rounded px-2 py-1 font-semibold max-w-[100px] overflow-hidden text-ellipsis whitespace-nowrap">
                  {course.minorName}
                </span>
              </div>
            )}
          </div>
        </div>
      ) : course.courseType === 'Requirement' ? (
        <div className="flex items-center justify-between p-2">
          <div className="w-1/5">
            <div className="course-number mr-4">
              <strong>{t('finalizedCourses.requirement', 'Requirement')}</strong>
            </div>
            <span
              className={`inline-flex ${
                course.isKept ? 'bg-white' : 'bg-blue-100'
              } text-blue-800 text-[9px] font-medium px-1 py-0.5 rounded mr-11`}
            >
              {course.Credits
                ? `${course.Credits} ${t('finalizedCourses.credits', 'Credits')}`
                : `3-5 ${t('finalizedCourses.credits', 'Credits')}`}
            </span>
          </div>
          <div className="flex-1 w-2/5 text-left pl-4 text-sm truncate">
            <span>{course.Requirements}</span>
          </div>
          <div className="flex flex-col items-start justify-center mr-5 text-left pl-2 text-sm ">
            {course.degreeName && (
              <div className="flex items-center justify-start">
                <span className="text-green-500 text-xs bg-green-100 bg-opacity-50 rounded px-2 py-1 font-semibold max-w-[100px] overflow-hidden text-ellipsis whitespace-nowrap">
                  {course.degreeName}
                </span>
              </div>
            )}
            {course.minorName && (
              <div className="flex items-center justify-start mt-1">
                <span className="text-yellow-500 text-xs bg-yellow-100 bg-opacity-50 rounded px-2 py-1 font-semibold max-w-[100px] overflow-hidden text-ellipsis whitespace-nowrap">
                  {course.minorName}
                </span>
              </div>
            )}
          </div>
        </div>
      ) : course.courseType === 'Milestone' ? (
        <div className={`flex items-center justify-between py-2 ${course.milestoneExistsInPlan ? 'bg-blue-100' : ''}`}>
          <div className="w-1/5">
            <div className="course-number ml-2 mb-2 mt-1">
              <strong>{t('finalizedCourses.milestone', 'Milestone')}</strong>
            </div>
          </div>
          <div className="flex-1 w-2/5 text-left pl-4 text-sm truncate">
            <span>{course.Requirements}</span>
          </div>
          <div className="flex flex-col items-start justify-center mr-8 text-left text-sm">
            {course.degreeName && (
              <div className="flex items-center justify-start ml-2 ">
                <span className="text-green-500 text-xs bg-green-100 bg-opacity-50 rounded px-2 py-1 font-semibold max-w-[100px] overflow-hidden text-ellipsis whitespace-nowrap">
                  {course.degreeName}
                </span>
              </div>
            )}
            {course.minorName && (
              <div className="flex items-center justify-start mt-1 ">
                <span className="text-yellow-500 text-xs bg-yellow-100 bg-opacity-50 rounded px-2 py-1 font-semibold max-w-[100px] overflow-hidden text-ellipsis whitespace-nowrap">
                  {course.minorName}
                </span>
              </div>
            )}
          </div>
        </div>
      ) : (
        <>
          <div className="flex items-center justify-between p-2">
            <div className="w-1/5">
              <div className="course-number mr-4">
                <strong>{course.courseInfo_courseNumber}</strong>
              </div>
              <span
                className={`inline-flex ${
                  course.isKept ? 'bg-white' : 'bg-blue-100'
                } text-blue-800 text-[9px] font-medium px-1 py-0.5 rounded mr-12`}
              >
                {course.Credits
                  ? `${course.Credits} ${t('finalizedCourses.credits', 'Credits')}`
                  : `3-5 ${t('finalizedCourses.credits', 'Credits')}`}
              </span>
            </div>
            <div className={`flex-1 w-2/5 text-left pl-4 text-sm font truncate ${isCardExpanded ? 'expanded' : ''}`}>
              <span>{course.courseInfo_courseName}</span>
            </div>
            <div className="flex flex-col items-start justify-center text-left pl-2 text-sm">
              {course.degreeName && (
                <div className="flex items-center justify-start">
                  <span className="text-green-500 text-xs bg-green-100 bg-opacity-50 rounded px-2 py-1 font-semibold max-w-[100px] overflow-hidden text-ellipsis whitespace-nowrap">
                    {course.degreeName}
                  </span>
                </div>
              )}
              {course.minorName && (
                <div className="flex items-center justify-start mt-1">
                  <span className="text-yellow-500 text-xs bg-yellow-100 bg-opacity-50 rounded px-2 py-1 font-semibold max-w-[100px] overflow-hidden text-ellipsis whitespace-nowrap">
                    {course.minorName}
                  </span>
                </div>
              )}
            </div>
            <div
              className={`cursor-pointer ${course.isKept ? 'text-gray-500' : ''}`}
              onClick={handleExpandClick}
            >
              {isCardExpanded ? (
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 15.75l7.5-7.5 7.5 7.5" />
                </svg>
              ) : (
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                </svg>
              )}
            </div>
          </div>
          {isCardExpanded && (
            <div className={`expandable-content ${isCardExpanded ? 'expanded' : ''}`}>
              <div className="p-4 text-sm">
                <div className="mb-2 text-left">
                  <strong>{t('finalizedCourses.description', 'Description:')}</strong>
                  <p className="mt-1">{course.Description}</p>
                </div>
                {!isPrereqMet && (
                  <p className="font-bold">
                    {t('finalizedCourses.prereqsWarning', 'Warning: Prerequisites not met.')}
                  </p>
                )}
                {hasPossibilities && showPossibilitiesButton && course.courseInfo_courseNumber !== 'FNCE 3030' && (
                  <div className="mb-2">
                    <button
                      className="justify-start text-black font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline transition duration-300 ease-in-out transform hover:scale-105 show-possibilities-button"
                      onClick={() => onShowPossibilitiesClick(course)}
                    >
                      {t('finalizedCourses.showPossibilities', 'Show Possibilities')}
                    </button>
                  </div>
                )}
                {hasPossibilities && !showPossibilitiesButton && (
                  <div>
                    <strong>{t('finalizedCourses.possibilitiesLabel', 'Possibilities:')}</strong>
                    <ul className="list-disc pl-4">
                      {course.Possibilities.split(',').map((possibility, index) => (
                        <li key={index}>{possibility}</li>
                      ))}
                    </ul>
                  </div>
                )}
                {course.courseInfo_courseNumber === 'FNCE 3030' && (
                  <div className="mb-2">
                    <button
                      className="text-black font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline transition duration-300 ease-in-out transform hover:scale-105 show-possibilities-button"
                      onClick={() => onShowPossibilitiesClick1(course)}
                    >
                      {t('finalizedCourses.showPossibilities', 'Show Possibilities')}
                    </button>
                  </div>
                )}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

const FinalizedCoursesTwo = ({
  finalizedCourses,
  semesterCourses,
  onRemove,
  prereqClasses,
  yearNumber,
  onCourseSelection,
  onKeepCourse,
  onKeepCourses,
  // IMPORTANT: The prop "semester" now is a dynamic term key (e.g. "1", "2", "3", …)
  semester,
  fetchedCourseData,
  transformedMajorRecData,
  electiveData,
  onElectiveClick,
  tabs,
  activeTab,
  selectedMajor1,
  handleKeepElectiveCourse,
  majorRecData,
  finalizedCourses1,
}) => {
  // console.log('FinalizedCourseS: ', finalizedCourses);
  const { currentUser, fetchedTerms } = useAuth();
  const { t } = useTranslation();

  // --- Build dynamic term map from fetchedTerms ---
  // Assume fetchedTerms is a JSON string like '{1:"Fall",2:"Spring",3:"Summer"}'
  const fixToJSON = (str) => str.replace(/(\{|,)\s*([0-9]+)\s*:/g, '$1 "$2":');
  const validJSONString = fixToJSON(fetchedTerms);
  const parsedTerms = JSON.parse(validJSONString);
  const termMap = {};
  Object.keys(parsedTerms).forEach((key) => {
    termMap[key] = parsedTerms[key];
  });
  const sortedTermKeys = Object.keys(termMap).sort((a, b) => Number(a) - Number(b));
  const dynamicTerms = sortedTermKeys.map((key) => termMap[key]);

  // Local state
  const [loading, setLoading] = useState(true);
  const [prerequisites, setPrerequisites] = useState([]);
  const [selectedCourses, setSelectedCourses] = useState([]); // Array of course IDs
  // Instead of using fixed S1/S2, we now use the dynamic term key directly.
  const [selectedSemester, setSelectedSemester] = useState(semester); // e.g. "1", "2", etc.
  const [selectedYear, setSelectedYear] = useState(yearNumber);
  const [finalizedSchedule, setFinalizedSchedule] = useState({});
  const [selectedPossibility, setSelectedPossibility] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showModal1, setShowModal1] = useState(false);
  const [currentCourse, setCurrentCourse] = useState(null);
  const [finalizedSemesterMilestones, setFinalizedSemesterMilestones] = useState({});
  const [finalizedMilestones, setFinalizedMilestones] = useState({});
  const [selectedElectiveCategory, setSelectedElectiveCategory] = useState([]);
  const [electiveYear, setElectiveYear] = useState([]);
  const [electiveSemester, setElectiveSemester] = useState([]);
  const [electiveRequirement, setElectiveRequirement] = useState([]);
  const [showSidebar, setShowSidebar] = useState(false);
  const [userSemesterCourses, setUserSemesterCourses] = useState([]);
  const [updatedCourses, setUpdatedCourses] = useState(finalizedCourses);

  // Fetch data from Firestore for the current user and active tab,
  // using dynamic term keys rather than fixed "S1"/"S2".
  useEffect(() => {
    const fetchData = async () => {
      try {
        const dbInstance = getFirestore();
        const docRef = doc(dbInstance, 'users', currentUser.uid);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const data = docSnap.data();
          const userActiveTab = data.activeTab;
          const finalizedSchedule = data.schedules?.[userActiveTab];
          setFinalizedSchedule(finalizedSchedule || {});

          // Use the dynamic term key (convert semester prop to string)
          const termKey = semester.toString();
          const courseIds =
            finalizedSchedule?.[`year${yearNumber}`]?.[termKey]?.courses || [];
          const fullCourseObjects = fetchedCourseData.filter((course) =>
            courseIds.includes(course.courseInfo_courseNumber)
          );
          setUserSemesterCourses(fullCourseObjects);

          const fm = data.finalizedMilestones;
          setFinalizedMilestones(fm);
          setFinalizedSemesterMilestones(
            fm?.[userActiveTab]?.[`year${yearNumber}`]?.[Number(termKey)] || {}
          );
        } else {
          console.log('No such document!');
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    if (currentUser) {
      fetchData();
    }
  }, [currentUser.uid, prereqClasses, fetchedCourseData, semester, yearNumber]);

  // Update courses with "isKept" flags
  useEffect(() => {
    const newUpdatedCourses = finalizedCourses.map((course) => {
      let prerequisiteMet = true; // (Use your actual logic here)
      let isKept = course?.isKept;

      if (course.courseType === 'Elective') {
        if (course.Possibilities === 'Free-NonMajor-Elective') {
          const majorCourseNumbers = finalizedCourses
            .filter((majorCourse) => majorCourse.courseType === 'Major Course')
            .map((majorCourse) => majorCourse.courseInfo_courseNumber);
          isKept = userSemesterCourses.some(
            (userCourse) =>
              !majorCourseNumbers.includes(userCourse.courseInfo_courseNumber)
          );
        } else {
          isKept = userSemesterCourses.some((userCourse) =>
            userCourse.Elective_fulfillment?.includes(course.Possibilities)
          );
        }
      } else if (course.courseType === 'Requirement') {
        const possibilities = course.Possibilities?.split(',').map((p) => p.trim());
        isKept = userSemesterCourses.some((userCourse) =>
          possibilities?.includes(userCourse.courseInfo_courseNumber)
        );
      } else if (course.courseType === 'Milestone') {
        isKept = finalizedSemesterMilestones['milestones']?.some(
          (milestone) => milestone.Title === course.Requirements
        );
      }
      return {
        ...course,
        isPrereqMet: prerequisiteMet,
        isKept: isKept,
      };
    });
    setUpdatedCourses(newUpdatedCourses);
  }, [finalizedCourses, userSemesterCourses, finalizedSemesterMilestones]);

  const handleElectiveClick = (category, yr, sem, requirement) => {
    setSelectedElectiveCategory(category);
    setElectiveYear(yr);
    setElectiveSemester(sem);
    setElectiveRequirement(requirement);
    setShowSidebar(true);
  };

  // Updated handleSaveMilestone: uses dynamic term keys instead of "S1"/"S2"
  const handleSaveMilestone = async (yearInput, title, description) => {
    // (Due date logic remains as in your original code – you may adjust if needed)
    let dueDate;
    if (semester.toString() === "1") {
      dueDate = `12-20-${2024 + yearInput}`;
    } else if (semester.toString() === "2") {
      dueDate = `5-10-${2025 + yearInput}`;
    } else {
      console.error('Invalid semester value. Expected dynamic term key "1" or "2" (or update logic accordingly).');
      return;
    }

    if (!title || !description || !dueDate || !semester || !yearInput) {
      console.error('Invalid input data');
      return;
    }

    // Instead of mapping to "S1"/"S2", we simply use the dynamic term key.
    const semesterKey = semester.toString();

    const newMilestone = {
      Milestone_ID: `milestone_${Date.now()}`,
      Title: title,
      Description: description,
      DueDate: dueDate,
      Milestone_Year: yearInput,
      Milestone_Sem: semesterKey,
      createdAt: new Date().toISOString(),
      completed: false,
    };

    try {
      if (currentUser && currentUser.uid) {
        const userDocRef = doc(db, 'users', currentUser.uid);
        const userDoc = await getDoc(userDocRef);
        if (!userDoc.exists()) {
          console.log('No such document!');
          return;
        }
        const userData = userDoc.data();
        const activeTabValue = userData.activeTab;
        const yearKey = `year${yearInput}`;
        // Use the dynamic term key
        const semesterKey = semester.toString();

        const existingMilestones =
          userData.finalizedMilestones?.[activeTabValue]?.[yearKey]?.[semesterKey]
            ?.milestones || [];

        const milestoneExists = existingMilestones.some(
          (milestone) => milestone.Title === title
        );

        let updatedMilestones;
        if (!milestoneExists) {
          updatedMilestones = [...existingMilestones, newMilestone];
          await setDoc(
            userDocRef,
            {
              finalizedMilestones: {
                ...userData.finalizedMilestones,
                [activeTabValue]: {
                  ...userData.finalizedMilestones?.[activeTabValue],
                  [yearKey]: {
                    ...userData.finalizedMilestones?.[activeTabValue]?.[yearKey],
                    [semesterKey]: { milestones: updatedMilestones },
                  },
                },
              },
            },
            { merge: true }
          );
          toast.success(
            t('finalizedCourses.milestoneAdded', {
              defaultValue:
                'Successfully added Milestone "{{title}}" to your {{semesterName}} {{specificYear}} Plan.',
              title,
              semesterName: termMap[semesterKey] || semesterKey,
              specificYear: yearInput,
            })
          );
        } else {
          updatedMilestones = existingMilestones;
          toast.warning(
            t('finalizedCourses.milestoneAlreadyExists', {
              defaultValue:
                'Milestone "{{title}}" already exists in your {{semesterName}} {{specificYear}} Plan.',
              title,
              semesterName: termMap[semesterKey] || semesterKey,
              specificYear: yearInput,
            })
          );
        }

        setFinalizedMilestones((prev) => ({
          ...prev,
          [activeTabValue]: {
            ...prev?.[activeTabValue],
            [yearKey]: {
              ...prev?.[activeTabValue]?.[yearKey],
              [semesterKey]: { milestones: updatedMilestones },
            },
          },
        }));
        setFinalizedSemesterMilestones((prev) => ({
          ...prev,
          milestones: updatedMilestones,
        }));
      }
    } catch (error) {
      console.error('Error saving milestone:', error);
    }
  };

  const handleCheckboxChange = (course, isChecked) => {
    if (isChecked) {
      setSelectedCourses([...selectedCourses, course.courseInfo_courseNumber]);
    } else {
      setSelectedCourses(
        selectedCourses.filter((id) => id !== course.courseInfo_courseNumber)
      );
    }
  };

  // Determine if there are any unkept courses:
const anyUnkeptCourses = finalizedCourses.some(
  (course) =>
    course.courseType !== 'Elective' &&
    course.courseType !== 'Requirement' &&
    course.courseType !== 'Milestone' &&
    !course.isKept
);

  const handleKeepCourseClick = (sel, yr, sem, keepAll = false) => {
    let coursesToKeep;
    if (keepAll) {
      coursesToKeep = finalizedCourses.filter(
        (course) =>
          course.courseType !== 'Elective' &&
          course.courseType !== 'Requirement' &&
          course.courseType !== 'Milestone' &&
          !course.isKept
      );
    } else {
      coursesToKeep = finalizedCourses.filter((course) =>
        sel.includes(course.courseInfo_courseNumber)
      );
    }
    if (coursesToKeep.length > 0) {
      onKeepCourse(coursesToKeep, yr, sem);
    }
    setSelectedCourses([]);
  };

  const handleShowPossibilitiesClick = (course) => {
    setCurrentCourse(course);
    setShowModal(true);
  };

  const handleShowPossibilitiesClick1 = (course) => {
    setCurrentCourse(course);
    setShowModal1(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setCurrentCourse(null);
  };

  const handlePossibilitySelection = async (course, possibility) => {
    const dbInstance = getFirestore();
    const docRef = doc(dbInstance, 'users', currentUser.uid);
    const updatedSched = { ...finalizedSchedule };
    if (!updatedSched[`year${selectedYear}`]) {
      updatedSched[`year${selectedYear}`] = {};
    }
    // Use the dynamic term key rather than "S" + selectedSemester
    const termKey = selectedSemester.toString();
    if (!updatedSched[`year${selectedYear}`][termKey]) {
      updatedSched[`year${selectedYear}`][termKey] = { courses: [] };
    }
    updatedSched[`year${selectedYear}`][termKey].courses.push(possibility);
    await setDoc(docRef, { finalizedSchedule: updatedSched }, { merge: true });
    setFinalizedSchedule(updatedSched);
    const courseWithPossibility = {
      ...course,
      courseInfo_courseNumber: possibility,
      isKept: true,
    };
    onKeepCourse([courseWithPossibility], selectedYear, selectedSemester);
    setSelectedPossibility(null);
  };

  const handleAddPlaceholder = async (course, yr, sem) => {
    try {
      console.log('Placeholder selection: ', course, yr, sem);
  
      if (currentUser && currentUser.uid) {
        const userDocRef = db.collection('users').doc(currentUser.uid);
        await db.runTransaction(async (transaction) => {
          const userDoc = await transaction.get(userDocRef);
  
          if (userDoc.exists) {
            const userData = userDoc.data();
            const previousFinalizedSchedule = userData.schedules[userData.activeTab] || {};
  
            const updateObj = previousFinalizedSchedule ? { ...previousFinalizedSchedule } : {};
            const yearKey = `year${yr}`;
            // Use the termMap to convert the numeric term (sem) into the friendly term name.
            const semesterKey = termMap[sem.toString()];
  
            // Get the existing placeholders for this year and term, if any
            const existingPlaceholders =
              updateObj[yearKey] &&
              updateObj[yearKey][semesterKey] &&
              updateObj[yearKey][semesterKey].Placeholders
                ? updateObj[yearKey][semesterKey].Placeholders.filter(
                    (course) => course.courseInfo_courseNumber === 'Placeholder'
                  )
                : [];
  
            // Generate a new PlaceholderID based on the count of existing placeholders
            const placeholderID =
              existingPlaceholders.length > 0
                ? `PH${existingPlaceholders.length + 1}`
                : 'PH1';
  
            // Create the placeholder course object
            const placeholderCourse = {
              courseInfo_courseNumber: 'Placeholder',
              courseInfo_courseName: course.Requirements,
              courseInfo_elective: course.Possibilities,
              Credits: course.Credits || 3,
              courseType: course.courseType,
              isKept: true,
              degreeName: course.degreeName,
              PlaceholderID: placeholderID, // New field for the placeholder ID
            };
  
            // Update the finalized schedule with the new placeholder
            const updatedFinalizedSchedule = {
              ...updateObj,
              [yearKey]: {
                ...updateObj[yearKey],
                [semesterKey]: {
                  ...(updateObj[yearKey] && updateObj[yearKey][semesterKey]
                    ? updateObj[yearKey][semesterKey]
                    : {}),
                  Placeholders: [
                    ...(updateObj[yearKey] &&
                    updateObj[yearKey][semesterKey] &&
                    updateObj[yearKey][semesterKey].Placeholders
                      ? updateObj[yearKey][semesterKey].Placeholders
                      : []),
                    placeholderCourse,
                  ],
                },
              },
            };
  
            console.log('Updated Finalized Schedule: ', updatedFinalizedSchedule);
  
            // Update the user's schedule in Firestore
            transaction.update(userDocRef, {
              [`schedules.${userData.activeTab}`]: updatedFinalizedSchedule,
            });
  
            toast.success(
              `Added placeholder ${placeholderID} for ${course.Requirements} to your schedule.`
            );
          } else {
            console.error('User data not found');
          }
        });
      } else {
        console.error('User is not authenticated');
      }
    } catch (error) {
      console.error('Error adding placeholder:', error);
    }
  };

  const getOrder = (courseType) => {
    if (!courseType || courseType === 'Major Course') {
      return 1; // Normal courses
    }
    switch (courseType) {
      case 'Elective':
        return 2;
      case 'Requirement':
        return 3;
      case 'Milestone':
        return 4;
      default:
        return 5;
    }
  };

  // Sort the courses
  updatedCourses.sort((a, b) => getOrder(a.courseType) - getOrder(b.courseType));
  // console.log('Updated Courses: ', updatedCourses);
  return (
    <div style={{ textAlign: 'center', marginTop: 'auto', padding: 0 }}>
      <div className="majorpage-courses">
        {updatedCourses.map((course, index) => (
          <FinalizedCourse
            key={index}
            course={course}
            onRemove={onRemove}
            isPrereqMet={course.isPrereqMet}
            onKeepCourse={handleKeepCourseClick}
            onCheckboxChange={handleCheckboxChange}
            selectedPossibility={selectedPossibility}
            finalizedSchedule={finalizedSchedule}
            selectedCourses={selectedCourses}
            onShowPossibilitiesClick={handleShowPossibilitiesClick}
            onShowPossibilitiesClick1={handleShowPossibilitiesClick1}
            year={selectedYear}
            semester={selectedSemester}
            isSelected={selectedCourses.includes(course.courseInfo_courseNumber)}
            onElectiveClick={handleElectiveClick}
            handleSaveMilestone={handleSaveMilestone}
            onAddPlaceholder={handleAddPlaceholder}
            semesterCourses={semesterCourses}
            finalizedCourses={finalizedCourses}
            finalizedSemesterMilestones={finalizedSemesterMilestones}
          />
        ))}
      </div>
      <div className="flex justify-between items-center mb-4" style={{ padding: 0, marginTop: 15 }}>
        <div className="flex items-center">
          <div className="mr-2">
            {/* Updated dynamic term dropdown: iterate over sortedTermKeys */}
            <select
              onChange={(e) => setSelectedSemester(e.target.value)}
              className="form-select form-select-sm tutorial-dropdown-semester"
              value={selectedSemester}
            >
              {sortedTermKeys.map((key) => (
                <option key={key} value={key}>
                  {termMap[key]}
                </option>
              ))}
            </select>
          </div>
          <div>
            <select
              onChange={(e) => setSelectedYear(parseInt(e.target.value))}
              className="form-select form-select-sm tutorial-dropdown-year"
              value={selectedYear}
            >
              <option value={1}>{t('finalizedCourses.year1', 'Year 1')}</option>
              <option value={2}>{t('finalizedCourses.year2', 'Year 2')}</option>
              <option value={3}>{t('finalizedCourses.year3', 'Year 3')}</option>
              <option value={4}>{t('finalizedCourses.year4', 'Year 4')}</option>
            </select>
          </div>
        </div>
        <div className="flex justify-end items-center space-x-2">
          <button
            type="button"
            onClick={() =>
              handleKeepCourseClick(selectedCourses, selectedYear, selectedSemester)
            }
            disabled={selectedCourses.length === 0}
            className={`!text-blue-700 !hover:text-white border border-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-2 py-2 text-center transition-all duration-300 flex items-center justify-center ${
              selectedCourses.length === 0
                ? 'hover:bg-blue-200 cursor-not-allowed'
                : 'hover:bg-blue-700 hover:!text-white'
            }`}
          >
            <FaCheck className="w-3 h-3 mr-2" />
            {t('finalizedCourses.keepSelected', 'Keep Selected')}
          </button>
          <button
            type="button"
            onClick={() =>
              handleKeepCourseClick(selectedCourses, selectedYear, selectedSemester, true)
            }
            disabled={finalizedCourses.length === 0 || !anyUnkeptCourses}
            className={`!text-blue-700 hover:!text-white border border-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:border-blue-500 dark:text-blue-500 dark:hover:bg-blue-500 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-2 py-2 text-center transition-all duration-300 flex items-center justify-center ${
              finalizedCourses.length === 0
                ? 'border-gray-500 cursor-not-allowed'
                : 'border-gray-500 hover:!bg-blue-700'
            }`}
          >
            <FaCheckDouble className="w-3 h-3 mr-2" />
            {t('finalizedCourses.keepAll', 'Keep All')}
          </button>
        </div>
      </div>
      {showModal && currentCourse && (
        <PossibilitiesModal
          course={currentCourse}
          isOpen={true}
          onClose={handleCloseModal}
          onKeepCourse={handleKeepElectiveCourse}
          year={selectedYear}
          semester={selectedSemester}
          finalizedSchedule={finalizedSchedule}
          majorRecData={majorRecData}
          finalizedCourses={finalizedCourses1}
          handleSaveMilestone={handleSaveMilestone}
        />
      )}
      {showSidebar && (
        <ElectiveSidebar
          onClose={() => setShowSidebar(false)}
          showSidebar={showSidebar}
          currPath={tabs[activeTab]}
          elective={selectedElectiveCategory}
          electiveYear={electiveYear}
          electiveSemester={electiveSemester}
          courses={fetchedCourseData}
          onKeepElectiveCourse={handleKeepElectiveCourse}
          majorRecData={transformedMajorRecData}
          requirement={electiveRequirement}
        />
      )}
      {showModal1 && currentCourse && null}
    </div>
  );
};

export default FinalizedCoursesTwo;
